import { Plus } from 'lucide-react'
import type { ComponentType } from 'react'
import type { SettingsFormProps } from './TurnSecondsField'
import { Button } from './ui'

interface Props<S> {
  Form: ComponentType<SettingsFormProps<S>>
  settings: S
  onChange: (next: S) => void
  onCreate: () => void
  creating: boolean
  disabled: boolean
  error: string | null
}

/** Game settings + "Create a room": the desktop card body and the phone sheet body are this. */
export function CreateRoomPanel<S>({
  Form,
  settings,
  onChange,
  onCreate,
  creating,
  disabled,
  error,
}: Props<S>) {
  return (
    <div className="flex flex-col gap-4">
      <Form value={settings} onChange={onChange} disabled={creating} />
      <Button onClick={onCreate} disabled={disabled || creating} className="w-full text-base">
        <Plus className="size-5" aria-hidden /> Create a room
      </Button>
      {error && <p className="text-sm text-rose-600">{error}</p>}
    </div>
  )
}
